import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import RadioButton from './radio_button';

/**
 * @visibleName Radio Group
 */

export default function RadioGroup(props) {
  const { className, 'data-aid': dataAid, isDisabled, onChange, options, value } = props;
  return (
    <RadioGroupWrapper className={className} data-aid={dataAid} isDisabled={isDisabled}>
      {options.map((item, idx) => (
        <RadioButton
          aria-checked={value === item.value}
          dataAid={`${dataAid}${idx}`}
          description={item.description}
          {...props}
          isChecked={value === item.value}
          key={`${dataAid}${idx}`}
          label={item.label}
          onChange={onChange}
          role="radio"
          value={item.value}
        />
      ))}
    </RadioGroupWrapper>
  );
}

RadioGroup.propTypes = {
  className: PropTypes.string,
  'data-aid': PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
    })
  ),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
};

RadioGroup.defaultProps = {
  'data-aid': 'radio-group',
  disabled: false,
  size: 'small',
  label: '',
  onChange: null,
  options: [],
  value: null,
};

const RadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  display: none;
`;
